// src/components/YouTubeGallery.js
import React from 'react';
import YouTube from 'react-youtube';

const YouTubeGallery = () => {

  const videoIds = [
    // 'ucCs-WNAdRE',
    'YczipXZ2lwE',
    '1E85DhUrTzk',
    'n7fZMuajmrM', // Replace with your YouTube video IDs
    'vrIS52ugAJE',
  ];

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <div className='vsection'>
      {videoIds.map((id, index) => (
        <div key={index} style={{ marginBottom: '20px' }} className="video-container" >
          <YouTube videoId={id} opts={opts}  />
        </div>
      ))}
    </div>
  );
};

export default YouTubeGallery;
